var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManualIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.0305 0.00789452C4.28989 0.103382 3.696 0.382859 3.18363 0.8766C2.04942 1.96889 1.92831 3.74123 2.90182 4.99189C3.83574 6.19364 5.5452 6.53367 6.85874 5.77676C8.01857 5.10834 8.61712 3.80878 8.37024 2.50222C8.13968 1.29349 7.16617 0.31066 5.9551 0.0614605C5.72453 0.0148811 5.21449 -0.0153952 5.0305 0.00789452Z",
    fill: "#C72B20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.84134 6.44566C1.80961 6.62732 0.864048 7.26779 0.274819 8.18307C0.151383 8.37638 0 8.70476 0 8.78162C0 8.93533 0.442504 9.5595 0.861719 9.99501C1.88414 11.0594 3.14644 11.6928 4.59972 11.8745C4.90248 11.9141 5.74557 11.9118 6.04368 11.8745C7.22214 11.7231 8.27018 11.2829 9.17615 10.5586C9.45795 10.335 10.0099 9.76444 10.2288 9.47332C10.4734 9.14494 10.6667 8.83286 10.6667 8.76066C10.6667 8.69079 10.5363 8.40433 10.4221 8.22732C10.0239 7.60549 9.4696 7.09777 8.84776 6.78802C8.39361 6.56211 7.82767 6.40607 7.54121 6.42703C7.44339 6.43402 7.37818 6.45731 7.28502 6.51553C6.94965 6.72747 6.84252 6.78569 6.6562 6.8672C6.19273 7.06983 5.71995 7.15833 5.2169 7.13737C4.5741 7.11175 4.03378 6.9394 3.49579 6.5854C3.37934 6.50854 3.2559 6.441 3.22097 6.43169C3.1837 6.4247 3.13945 6.41538 3.12082 6.41073C3.10219 6.40607 2.97642 6.42237 2.84134 6.44566Z",
    fill: "#C72B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualIcon);
export default __webpack_public_path__ + "static/media/manualIcon.8dc6597213e8e01c5c0c73a39bb47fbd.svg";
export { ForwardRef as ReactComponent };